import { URL_PREFIX } from 'ev-config/config';

export const PROVIDER_ROOT = `${URL_PREFIX}/provider`;

export enum ProviderPaths {
  WaitingRoom = 'waiting_room',
  Patients = 'patients',
  VisitHistory = 'visit_history',
  Scheduling = 'scheduling',
  CheckIn = 'check_in',
  MyAccount = 'my_account',
  UserAvatar = 'user_avatar',
  SwitchPractice = 'switch_practice',
  BulkUserProvision = 'bulk_user_provision',
  ReportRun = 'report_run',
  Availability = 'availability',
  PersonalInfo = 'personal_info',
}
